import Emitter from '../services/emitter';
import store from '../reducers';
import UserAction from '../reducers/user';

class Account {
    constructor() {

    }

    setLogin(state) {
        store.dispatch(UserAction.setLoginState(state));
        if(state) {
            Emitter.emit('Login');
        } else {
            Emitter.emit('Logout');
        }
    }
}

export default Account;